export { default as LocationInfo } from './LocationInfo';
